import React from 'react'
import { _ } from '@iskytrip/sdk'
import BaseComponent from '@base/BaseComponent'
import CSS from './index.module.css'

class Index extends BaseComponent {
	componentDidMount() {
		console.log('Component CouponItem')
	}

	itemPress(item) {
		console.log(item)
		if (this.isGray()) {
			return
		}
		this.props.itemPress && this.props.itemPress(item)
	}

	itemBtnPress(item, e) {
		console.log(item)
		// 阻止事件冒泡
		e.stopPropagation()
		e.nativeEvent.stopImmediatePropagation()
		this.props.itemBtnPress && this.props.itemBtnPress(item)
	}

	isGray() {
		// status 状态 0:已领取,1:已使用,98:已作废,99:已过期,100:已领完
		const item = this.props.item || {}
		if (+item.status !== 0) {
			return true
		}
		return false
	}

	render() {
		const rowID = this.props.rowID || ''
		const item = this.props.item || {}
		const style = this.props.style || {}

		let btnComponent = null
		// couponButtonCode 按钮标识码
		// 10：立即领取 20：去使用 30：查看券码 40：已领完
		if (_.isHasValue(item.couponButtonCode)) {
			btnComponent = (
				<p
					className={+item.couponButtonCode === 10 ? CSS.btnStyle1 : CSS.btnStyle2}
					onClick={this.itemBtnPress.bind(this, item)}
				>
					{item.buttonDesc}
				</p>
			)
		}
		if (!this.props.canUse) {
			btnComponent = null
		}
		// btnComponent = (
		// 	<p
		// 		className={+item.buttonCode === 10 ? CSS.btnStyle1 : CSS.btnStyle2}
		// 		onClick={this.itemBtnPress.bind(this, item)}
		// 	>
		// 		去使用
		// 	</p>
		// )

		const isGrayColor = this.isGray()

		return (
			<div
				key={rowID}
				className={CSS.cell}
				style={style}
				onClick={this.itemPress.bind(this, item)}
			>
				<div className={CSS.cellLeft}>
					<div className={CSS.cellLeft1}>
						<p
							className={isGrayColor ? CSS.gray : ''}
							style={{ fontSize: isNaN(item.discountValue) ? '.28rem' : '.48rem' }}
						>
							{item.discountValue || ''}
						</p>
						<p className={isGrayColor ? CSS.gray : ''}>{item.discountUnit || ''}</p>
					</div>
					<p
						className={
							isGrayColor ? `${CSS.cellLeft2} ${CSS.gray}` : `${CSS.cellLeft2}`
						}
					>
						{item.discountText || ''}
					</p>
				</div>
				<div className={CSS.cellMiddle}>
					<p
						className={
							+item.status !== 0
								? `${CSS.cellMiddleTitle} ${CSS.gray}`
								: `${CSS.cellMiddleTitle}`
						}
					>
						{/*{_.isHasValue(item.labelIcon) ? (*/}
						{/*	<img className={CSS.cellMiddleTag} src={item.labelIcon} alt='' />*/}
						{/*) : null}*/}
						{item.relationName || ''}
					</p>
					<p
						className={
							isGrayColor
								? `${CSS.cellMiddleContent} ${CSS.gray}`
								: `${CSS.cellMiddleContent}`
						}
					>
						{item.relationExpiryDate || ''}
					</p>
				</div>
				<div className={CSS.cellRight}>{btnComponent}</div>
				{/*{_.isHasValue(item.equityTagImg) ? (*/}
				{/*	<img className={CSS.cellTagImg1} src={item.equityTagImg || ''} alt='' />*/}
				{/*) : null}*/}
				{_.isHasValue(item.stampImg) ? (
					<img className={CSS.cellTagImg2} src={item.stampImg || ''} alt='' />
				) : null}
			</div>
		)
	}
}

export default Index
